import React from 'react'
import Navbar from '../components/Navbar'
import bg1 from '../assets/bg-presonalmedia.jpg'
import Footer from '../components/Footer'
import StronaWBudowie from '../components/StronaWBudowie'

function Personalmedia() {
  return (
    <div>
    <Navbar />
    <div className='pt-20 flex justify-center mx-auto static'>
        <div className='bg-white bg-opacity-90 absolute mx-auto justify-center mt-32 max-w-[450px] text-center py-2 rounded-xl px-2'>
          <h3 className='uppercase text-xl md:text-3xl font-semibold pb-2'>Personal media</h3>
        </div>
      <img src={bg1} alt="background photo" className='w-screen h-96 object-cover'/>
    </div>
    
    <div className='max-w-[1240px] bg-white mx-auto justify-center'>
    <StronaWBudowie />
    <Footer />

    </div>  
    </div>
  )
}

export default Personalmedia